import * as images from "@/components/images/Images";
import { AboutUsOurRootsData } from "./types";

export const aboutUsOurRootsData: AboutUsOurRootsData = {
  title: "Our roots",
  description: [
    "Ebad Akbari is a former translator fluent in four languages who spent a rich career providing and establishing language services for the US Government.",
    "In his role, he often needed documents translated. He explored a variety of online providers, never finding the ideal, excellent solution. They were inefficient, costly, and complicated experiences with frustrating customer service, and the translations were never accurate.",
    "He knew there was a better way—where businesses didn’t need to compromise on quality translations, speed, or service.",
    "In 2019, he delivered language excellence across all business areas with Languex. It serves individuals and businesses with customer-first translation services and the highest quality translations quickly, at a fair price.",
  ],
  imageUrl: images.aboutUsOurRoots,
  imageDimensions: {
    width: 802,
    height: 854,
  },
} as const;
